import { createFileRoute } from '@tanstack/react-router';

import { RouterContext } from '~/types/router.type';

import { Invoice } from '~/modules/invoice/detail';

import { i18n } from '~/utils';
import { getRouteHead } from '~/utils/routeUtils';

import { getInvoice } from '../-routeParams';

const title = i18n.t(($) => $.pageTitle.detail, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/incoming/$invoiceId/')({
  beforeLoad: ({ context, params }) => getInvoice({ context, params }),
  component: Invoice,
  head: ({ loaderData }: { loaderData?: RouterContext }) =>
    getRouteHead(`${title} ${loaderData?.pageData?.title ?? ''}`),
  loader: ({ context }) => context,
  staticData: {
    AppBar: {
      title,
    },
  },
});
